import React from 'react';
import { string } from 'prop-types';

import PageTitle from '../../components/PageTitle';
import {
  FormWrapper,
  FlexWrapper,
  SignatureIcon,
  ControlP,
  SignLink,
} from '../styles';

Sign.propTypes = {
  signLinkMember1: string,
  signLinkMember2: string,
  nameMember1: string,
  nameMember2: string,
};

Sign.defaultProps = {
  signLinkMember1: null,
  signLinkMember2: null,
  nameMember1: null,
  nameMember2: null,
};

function Sign({ signLinkMember1, signLinkMember2, nameMember1, nameMember2 }) {
  return (
    <div>
      <PageTitle>Signering med Bank-ID</PageTitle>
      <FormWrapper>
        <FlexWrapper mobileColumn>
          <FlexWrapper flex="column" mobileCentered mobileColumn flexPart={2}>
            <h2>Nu är det dags att signera din ansökan!</h2>

            <ControlP>
              Nu har alla dina dokument och din information blivit godkänd av
              oss på Bytesansökan, bra jobbat!
            </ControlP>

            <ControlP>
              Du kommer inom kort få ett e-postmeddelande av Scrive. Följ
              anvisningarna i det e-postmeddelandet för att signera och godkänna
              din bytesansökan. Om du inte får meddelandet från Scrive inom
              kort, vänligen kolla skräpposten då det kan ha hamnat fel.
              Kontakta kundtjänst om du fortfarande inte hittar det.
            </ControlP>

            <ControlP>
              Observera att detta endast är en ansökan och inget bindande
              kontrakt. Fram tills dess att bytet är godkänt och de nya
              hyreskontrakten påskrivna står det var och en fritt att avbryta.
              Med hänsyn till övriga bytesparter så bör detta undvikas i största
              möjliga mån.
            </ControlP>

            <ControlP>
              Så snart samtliga signerat ansökningarna så skickas dessa till
              respektive hyresvärd.
            </ControlP>

            {signLinkMember1 !== 'Signering hanteras av Scrive' && (
              <FlexWrapper mobileCentered padding="0" margin="40px 0 0 0">
                <SignLink url={signLinkMember1}>
                  Signering för {nameMember1}
                </SignLink>
              </FlexWrapper>
            )}

            {signLinkMember2 !== 'Signering hanteras av Scrive' &&
              signLinkMember2 && (
                <FlexWrapper mobileCentered padding="0" margin="40px 0 20px 0">
                  <SignLink url={signLinkMember2}>
                    Signering för {nameMember2}
                  </SignLink>
                </FlexWrapper>
              )}
          </FlexWrapper>
          <FlexWrapper centered flexPart={1}>
            <SignatureIcon />
          </FlexWrapper>
        </FlexWrapper>
      </FormWrapper>
    </div>
  );
}

export default Sign;



// WEBPACK FOOTER //
// ./src/views/Sign/index.js